import React from "react";
import { motion } from "framer-motion";

const ResultCard = ({ result }) => {
  return (
    <motion.div
      className="bg-white  rounded-xl border-2 border-green-700 "
      initial={{ opacity: 0, scale: 0.8, rotate: -10 }}
      animate={{ opacity: 1, scale: 1, rotate: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      whileHover={{ scale: 1.05, rotate: -5 }}
      style={{
        width: "100%",
        maxWidth: "400px",
        height: "auto",
        minHeight: "200px",
      }}
    >
      <h1 className="p-4 text-center font-bold text-lg md:text-xl lg:text-2xl flex justify-center items-center mt-16 font-body">
        Property value:
        <span className="text-green-700 font-bold ml-1 ">
          {" "}
          ₹ {result.toLocaleString("en-IN")}
        </span>
      </h1>
    </motion.div>
  );
};

export default ResultCard;
